// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Trj34","loader":"styles_loader__8Gwwc"};